import { IconButton, Input, InputGroup, InputRightElement, Tooltip } from "@chakra-ui/react";
import React, { useState } from "react";
import { MdFileUpload } from "react-icons/md";

import { ImportTaskBroDomainEnum, Organisation } from "@nens/brostar/openapi-client";

import { useStartBroIdImport } from "../api/start-bro-id-import-task";

const VALID_BRO_PREFIXES = Object.values(ImportTaskBroDomainEnum) as string[];
const MAX_BRO_ID_LENGTH = 15;

function isValidBroId(value: string): boolean {
  return value.length >= 3 && VALID_BRO_PREFIXES.includes(value.slice(0, 3).toUpperCase());
}

type Props = {
  organisation: Organisation | undefined;
};

const ImportBroIdBar: React.FC<Props> = ({ organisation }) => {
  const [value, setValue] = useState("");
  const startBroIdImport = useStartBroIdImport();

  if (organisation === undefined) return null;

  const hasEnoughChars = value.length >= 3;
  const isInvalid = hasEnoughChars && !isValidBroId(value);
  const canSubmit = isValidBroId(value);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const next = e.target.value.toUpperCase().slice(0, MAX_BRO_ID_LENGTH);
    setValue(next);
  };

  const handleSubmit = () => {
    if (!canSubmit) return;
    startBroIdImport(organisation, value);
    setValue("");
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") handleSubmit();
  };

  return (
    <Tooltip
      label={
        isInvalid ? `Ongeldige BRO-ID. Geldige prefixen: ${VALID_BRO_PREFIXES.join(", ")}` : ""
      }
      isDisabled={!isInvalid}
    >
      <InputGroup size="sm" w="160px">
        <Input
          placeholder="BRO-ID"
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          maxLength={MAX_BRO_ID_LENGTH}
          isInvalid={isInvalid}
          borderRadius="md"
          aria-label="BRO-ID importveld"
        />
        <InputRightElement>
          <IconButton
            aria-label="Start import voor BRO-ID"
            icon={<MdFileUpload />}
            size="xs"
            variant="ghost"
            isDisabled={!canSubmit}
            onClick={handleSubmit}
          />
        </InputRightElement>
      </InputGroup>
    </Tooltip>
  );
};

export { ImportBroIdBar };
